import { animate, state, style, transition, trigger } from '@angular/animations'
import { Component, ElementRef, Input, OnInit, output, viewChild } from '@angular/core'

const iconUrl = 'assets/img/icons/down-arrow.svg'

@Component({
  selector: 'app-tutorial-box',
  templateUrl: 'tutorial-box.component.html',
  styleUrls: ['tutorial-box.component.scss'],
  animations: [
    trigger('toggleAnimation', [
      transition(':enter', [
        style({ height: '0px' }),
        animate('300ms ease-in-out', style({ height: '*' })),
      ]),
      transition(':leave', [
        style({ height: '*' }),
        animate('300ms ease-in-out', style({ height: '0px' })),
      ]),
    ]),
    trigger('rotateAnimation', [
      state(
        'down',
        style({
          transform: 'rotate(0deg)',
        }),
      ),
      state(
        'up',
        style({
          transform: 'rotate(-180deg)',
        }),
      ),
      transition('down => up', animate('300ms ease-in')),
      transition('up => down', animate('300ms ease-out')),
    ]),
    trigger('removeAnimation', [
      transition(':leave', [
        style({ height: '*' }),
        animate('300ms ease-in-out', style({ height: '0px' })),
      ]),
    ]),
  ],
  standalone: false,
})
export class TutorialBoxComponent implements OnInit {
  @Input()
  initOpen = false

  @Input()
  titleText!: string

  @Input()
  cta?: string

  @Input()
  ctaTitle?: string

  @Input()
  removeOnDismiss = false

  // eslint-disable-next-line @angular-eslint/no-output-native
  toggle = output<void>()

  hide = output<boolean>()

  readonly box = viewChild.required<ElementRef>('box')

  readonly openBox = viewChild.required<ElementRef>('openBox')

  open = this.initOpen
  showBox = true
  icon = iconUrl

  ngOnInit(): void {
    this.open = this.initOpen
    this.icon = iconUrl
  }

  onToggle(): void {
    if (this.removeOnDismiss) return
    this.open = !this.open
  }

  dismiss(): void {
    this.showBox = false
  }

  removeBox(): void {
    if (this.showBox) return

    this.hide.emit(this.open)
  }

  animationDone(): void {
    this.toggle.emit()

    if (this.open) {
      this.box().nativeElement.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      })
    }
  }
}
